/**
 * Step Selector V3 — Product Configurator
 *
 * Expects window.__stepSelectorConfig to be set by inline Liquid before this
 * script loads. All Liquid-dependent values live there; this file is static.
 */
(function () {
  'use strict';

  // ===== Configuration =====
  var DEBUG = false;
  var config = window.__stepSelectorConfig || {};

  function log() {
    if (DEBUG) console.log.apply(console, arguments);
  }

  // ===== Lightweight HTML sanitizer (replaces DOMPurify) =====
  // Uses DOMParser to parse HTML, then walks the tree and strips
  // disallowed tags/attributes. Safe for first-party content from
  // Shopify admin / pragma-app.
  function sanitizeHTML(html, options) {
    if (!html) return '';
    options = options || {};
    var allowedTags = {};
    (options.ALLOWED_TAGS || ['p', 'br', 'strong', 'em', 'ul', 'li', 'ol']).forEach(function (t) {
      allowedTags[t] = true;
    });
    var allowedAttrs = {};
    (options.ALLOWED_ATTR || []).forEach(function (a) {
      allowedAttrs[a] = true;
    });
    var doc = new DOMParser().parseFromString(html, 'text/html');

    function walk(node) {
      var children = Array.prototype.slice.call(node.childNodes);
      children.forEach(function (child) {
        if (child.nodeType === 1) {
          if (!allowedTags[child.tagName.toLowerCase()]) {
            while (child.firstChild) child.parentNode.insertBefore(child.firstChild, child);
            child.parentNode.removeChild(child);
          } else {
            Array.prototype.slice.call(child.attributes).forEach(function (attr) {
              if (!allowedAttrs[attr.name]) child.removeAttribute(attr.name);
            });
            walk(child);
          }
        }
      });
    }

    walk(doc.body);
    return doc.body.innerHTML;
  }

  // Decode HTML entities (standalone Liquid templates escape " as &quot; etc.)
  function decodeHTMLEntities(str) {
    if (!str || str.indexOf('&') === -1) return str;
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  // ===== Shopify image URL helper (single source of truth) =====
  // Legacy filename suffixes (_100x100.jpg) only work on old product-image paths —
  // not on metafield "files" URLs, and not on Appwrite URLs. The CDN ?width= param
  // works on every cdn.shopify.com URL and also enables auto WebP/AVIF.
  var LEGACY_SIZE_WIDTHS = { pico: 16, icon: 32, thumb: 50, small: 100, compact: 160, medium: 240, large: 480, grande: 600, original: 0, master: 0 };
  function sizeToWidth(size) {
    if (!size) return 0;
    if (typeof size === 'number') return size;
    var named = LEGACY_SIZE_WIDTHS[String(size).toLowerCase()];
    if (named !== undefined) return named;
    var m = String(size).match(/^(\d+)x(\d+)$/i);
    if (m) return Math.max(parseInt(m[1], 10), parseInt(m[2], 10));
    var n = parseInt(size, 10);
    return isNaN(n) ? 0 : n;
  }
  function shopifyImageUrl(url, size) {
    if (!url) return '';
    // Strip existing Shopify size suffix
    var clean = url.replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande|original|master|100x100|1024x1024|\d+x\d+)\.(jpg|jpeg|png|gif|webp)/i,
      '.$2'
    );
    // Non-Shopify hosts (Appwrite, Drive) have no resizer — return as-is.
    if (clean.indexOf('cdn.shopify.com') === -1) return clean;
    // Strip any width we set earlier, then apply the requested one.
    clean = clean.replace(/([?&])width=\d+(&?)/, function (_, pre, post) { return post ? pre : ''; }).replace(/[?&]$/, '');
    var width = sizeToWidth(size);
    if (!width) return clean;
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function imageSrcset(url, widths) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return '';
    return widths.map(function (w) { return shopifyImageUrl(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  // ===== Read more / less =====
  function applyReadMoreFunctionality(element, htmlContent) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    var fullText = tempDiv.textContent || tempDiv.innerText || '';
    var MAX_LENGTH = 200;
    if (fullText.length <= MAX_LENGTH) { element.innerHTML = htmlContent; return; }

    var truncatedText = fullText.substring(0, MAX_LENGTH).trim() + '...';
    var collapsedContainer = document.createElement('span');
    collapsedContainer.className = 'description-collapsed';
    var truncatedSpan = document.createElement('span');
    truncatedSpan.textContent = truncatedText;
    var readMoreLink = document.createElement('span');
    readMoreLink.className = 'read-more-link';
    readMoreLink.textContent = 'Lees meer';
    collapsedContainer.appendChild(truncatedSpan);
    collapsedContainer.appendChild(readMoreLink);

    var expandedContainer = document.createElement('span');
    expandedContainer.className = 'description-expanded';
    expandedContainer.style.display = 'none';
    var fullSpan = document.createElement('span');
    fullSpan.innerHTML = htmlContent;
    var readLessLink = document.createElement('span');
    readLessLink.className = 'read-more-link';
    readLessLink.textContent = 'Lees minder';
    expandedContainer.appendChild(fullSpan);
    expandedContainer.appendChild(document.createTextNode(' '));
    expandedContainer.appendChild(readLessLink);

    readMoreLink.onclick = function () { collapsedContainer.style.display = 'none'; expandedContainer.style.display = 'inline'; };
    readLessLink.onclick = function () { expandedContainer.style.display = 'none'; collapsedContainer.style.display = 'inline'; };

    element.innerHTML = '';
    element.appendChild(collapsedContainer);
    element.appendChild(expandedContainer);
  }

  // ===== State =====
  var selectedSize = '';
  var selectedFabric = '';
  var selectedVariant = null;
  var selectedProductHandle = '';
  var selectedProductId = null;
  var selectedProductTitle = '';
  var selectedProductPrice = 0;
  var selectedProductImageUrl = '';
  var drawerOpen = false;
  var variants = [];
  var fabricGalleries = {};
  var fabricMetafields = {};
  var productSizeGuideImage = null;

  // ===== Caches & memory management =====
  var MAX_PRODUCT_CACHE_SIZE = 5;
  var productDataLRU = new Map();
  var ENABLE_GALLERY_THUMBS = false;
  var metafieldCache = {};
  var debounceTimers = {};
  var sizeSortingCache = {};
  var galleryAbortControllers = [];
  var productCardsAbortController = null;
  var cardObserver = null;
  var globalListenersAbortController = null;
  var addToCartInProgress = false;
  var activeImageRequest = null;

  // ===== Bottom bar settings (from Liquid config) =====
  var bottomBarSettings = {
    enabled: config.bottomBarEnabled !== undefined ? config.bottomBarEnabled : true,
    step1Primary: config.barStep1PrimaryText || 'Kies dit model en selecteer je stof \u2192',
    step2Secondary: config.barStep2SecondaryText || 'Terug',
    step2Primary: config.barStep2PrimaryText || 'selecteer je maat',
    step3Secondary: config.barStep3SecondaryText || 'Voeg toe en maak nog \u00E9\u00E9n',
    step3Primary: config.barStep3PrimaryText || 'Naar winkelmandje',
    inspireUrl: config.inspireUrl || '',
    inspireText: config.inspireText || 'Laat je inspireren',
    inspireEnabled: config.inspireEnabled || false
  };

  // Some labels differ on mobile (e.g. "wijzig model" \u2192 "Terug")
  function isMobileViewport() { return window.innerWidth <= 768; }

  // ===== Price formatting =====
  function formatBarPrice(cents) {
    if (!cents) return '';
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  // Build the bar summary from parts. A part with {link:true} is underlined and
  // (optionally) clickable; plain parts render as text.
  function setBarSummary(el, parts) {
    el.innerHTML = '';
    parts.forEach(function (p) {
      if (!p || !p.text) return;
      if (p.link) {
        var span = document.createElement('span');
        span.className = 'bar-model';
        span.textContent = p.text;
        if (p.onClick) span.addEventListener('click', p.onClick);
        el.appendChild(span);
      } else {
        el.appendChild(document.createTextNode(p.text));
      }
    });
  }

  // ===== Bottom bar =====
  function updateBottomBar(step, isDrawerMode) {
    if (!bottomBarSettings.enabled) return;
    var bar = document.getElementById('configurator-bottom-bar');
    var summaryEl = document.getElementById('bar-summary-text');
    var primaryBtn = document.getElementById('bar-btn-primary');
    var secondaryBtn = document.getElementById('bar-btn-secondary');
    if (!bar || !summaryEl || !primaryBtn || !secondaryBtn) return;

    if (step === 1 && !isDrawerMode) { hideBottomBar(); return; }

    bar.style.display = 'block';
    document.body.classList.add('configurator-bar-active');
    requestAnimationFrame(function () { bar.classList.add('visible'); adjustBarForFooter(); });

    if (step === 1 && isDrawerMode) {
      var price = selectedProductPrice ? formatBarPrice(selectedProductPrice) : '';
      // Step 1: no underline
      setBarSummary(summaryEl, [{ text: selectedProductTitle + (price ? ' — ' + price : '') }]);
      if (bottomBarSettings.inspireEnabled && bottomBarSettings.inspireUrl) {
        secondaryBtn.textContent = bottomBarSettings.inspireText;
        secondaryBtn.style.display = 'inline-block';
        secondaryBtn.onclick = function () { window.open(bottomBarSettings.inspireUrl, '_blank'); };
      } else { secondaryBtn.style.display = 'none'; }
      primaryBtn.textContent = bottomBarSettings.step1Primary;
      primaryBtn.onclick = function () { confirmProductAndGoToStep2(); };
    }

    if (step === 2) {
      var price2 = selectedProductPrice ? formatBarPrice(selectedProductPrice) : '';
      var rest2 = (selectedFabric ? ' ' + selectedFabric : '') + (price2 ? ' \u2014 ' + price2 : '');
      // Step 2: underline the model \u2192 click goes back to step 1
      setBarSummary(summaryEl, [
        { text: selectedProductTitle, link: true, onClick: function () { prevStep(1); } },
        { text: rest2 }
      ]);
      // #44 — on mobile this back action reads "Terug" instead of "wijzig model"
      secondaryBtn.textContent = isMobileViewport() ? 'Terug' : bottomBarSettings.step2Secondary;
      secondaryBtn.style.display = 'inline-block';
      secondaryBtn.onclick = function () { prevStep(1); };
      primaryBtn.textContent = bottomBarSettings.step2Primary;
      primaryBtn.onclick = function () { nextStep(3); };
    }

    if (step === 3) {
      var variantPrice = selectedVariant ? selectedVariant.price : selectedProductPrice;
      var price3 = variantPrice ? formatBarPrice(variantPrice) : '';
      var tail3 = (selectedSize ? ' in maat ' + selectedSize : '') + (price3 ? ' \u2014 ' + price3 : '');
      // Step 3: underline the fabric \u2192 click goes back to step 2
      setBarSummary(summaryEl, [
        { text: selectedProductTitle + ' ' },
        { text: selectedFabric || '', link: true, onClick: function () { prevStep(2); } },
        { text: tail3 }
      ]);
      secondaryBtn.textContent = bottomBarSettings.step3Secondary;
      secondaryBtn.style.display = 'inline-block';
      // "Add to cart AND Configureer opnieuw": add current item, then reset to step 1
      secondaryBtn.onclick = function () { addToCart(true); };
      primaryBtn.textContent = bottomBarSettings.step3Primary;
      primaryBtn.onclick = function () { addToCart(); };
    }
  }

  function hideBottomBar() {
    var bar = document.getElementById('configurator-bottom-bar');
    if (bar) {
      bar.classList.remove('visible');
      bar.style.transform = '';
      document.body.classList.remove('configurator-bar-active');
      setTimeout(function () { bar.style.display = 'none'; }, 300);
    }
  }

  // #38 — keep the fixed bar pinned to the bottom, but lift it above the footer
  // once the footer scrolls into view so it never overlaps it.
  function adjustBarForFooter() {
    var bar = document.getElementById('configurator-bottom-bar');
    if (!bar || !bar.classList.contains('visible')) return;
    var footer = document.querySelector('.footer, footer, [id*="section-footer"]');
    if (!footer) { bar.style.transform = ''; return; }
    var overlap = window.innerHeight - footer.getBoundingClientRect().top;
    bar.style.transform = overlap > 0 ? 'translateY(-' + Math.round(overlap) + 'px)' : '';
  }

  function saveConfigurator() {
    var cfg = {
      productHandle: selectedProductHandle,
      productTitle: selectedProductTitle,
      fabric: selectedFabric,
      size: selectedSize,
      variantId: selectedVariant ? selectedVariant.id : null,
      timestamp: Date.now()
    };
    try {
      var saved = JSON.parse(localStorage.getItem('savedConfigurations') || '[]');
      saved.push(cfg);
      localStorage.setItem('savedConfigurations', JSON.stringify(saved));
    } catch (e) { log('[SaveConfigurator] localStorage error:', e); }
    var secondaryBtn = document.getElementById('bar-btn-secondary');
    if (secondaryBtn) {
      secondaryBtn.textContent = 'Opgeslagen!';
      setTimeout(function () { secondaryBtn.textContent = bottomBarSettings.step3Secondary; }, 2000);
    }
  }

  // ===== Product detail drawer =====
  function openProductDrawer(handle, productId, title, imageUrl, price, sizeGuideImage) {
    var drawer = document.getElementById('product-detail-drawer');
    var overlay = document.getElementById('product-drawer-overlay');
    var titleEl = document.getElementById('drawer-product-title');
    var descEl = document.getElementById('drawer-product-description');
    if (!drawer) return;

    selectedProductHandle = handle;
    selectedProductId = productId;
    selectedProductTitle = title;
    selectedProductImageUrl = imageUrl;
    selectedProductPrice = price;
    drawerOpen = true;

    document.querySelectorAll('.product-card').forEach(function (card) { card.classList.remove('selected'); });
    var selectedCard = document.querySelector('.product-card[data-product-id="' + productId + '"]');
    if (selectedCard) selectedCard.classList.add('selected');

    if (drawer) drawer.dataset.isHelp = '';
    if (titleEl) titleEl.textContent = title;
    if (descEl) descEl.innerHTML = '<p>Laden...</p>';

    // Per-product lookbook content (subtitle / description override / lookbook link) from the card
    var card = document.querySelector('.product-card[data-product-id="' + productId + '"]');
    var manualSubtitle = card ? (card.getAttribute('data-subtitle') || '') : '';
    var manualDescription = card ? (card.getAttribute('data-description') || '') : '';
    var lookbookUrl = card ? (card.getAttribute('data-lookbook-url') || '') : '';
    var subtitleEl = document.getElementById('drawer-product-subtitle');
    if (subtitleEl) {
      if (manualSubtitle) { subtitleEl.textContent = manualSubtitle; subtitleEl.style.display = ''; }
      else { subtitleEl.textContent = ''; subtitleEl.style.display = 'none'; }
    }
    var lookbookEl = document.getElementById('drawer-lookbook-link');
    if (lookbookEl) {
      if (lookbookUrl) { lookbookEl.href = lookbookUrl; lookbookEl.textContent = 'Bekijk de look →'; lookbookEl.style.display = ''; }
      else lookbookEl.style.display = 'none';
    }
    // Show the manual (lookbook) description right away so it survives a fetch failure
    if (descEl && manualDescription) {
      descEl.innerHTML = sanitizeHTML(manualDescription, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'li', 'ol', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        ALLOWED_ATTR: ['href', 'target', 'rel']
      });
    }

    var galleryEl = document.getElementById('drawer-gallery');
    if (galleryEl) {
      var track = galleryEl.querySelector('.drawer-gallery-track');
      if (track) track.innerHTML = '';
    }

    fetch('/products/' + handle + '.js', { signal: AbortSignal.timeout(10000) })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var drawerDesc = manualDescription || product.description;
        if (descEl && drawerDesc) {
          descEl.innerHTML = sanitizeHTML(drawerDesc, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'li', 'ol', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            ALLOWED_ATTR: ['href', 'target', 'rel']
          });
        } else if (descEl) {
          descEl.innerHTML = '';
        }
        if (product.price) { selectedProductPrice = product.price; updateBottomBar(1, true); }

        // Build drawer gallery: stack all product images vertically
        if (galleryEl) {
          var track = galleryEl.querySelector('.drawer-gallery-track');
          if (!track) return;
          track.innerHTML = '';

          // Product-level images first, then variant images. Never material images/gallery.
          var productImgs = [];
          var variantImgs = [];
          if (product.media && product.media.length > 0) {
            product.media.forEach(function (m) {
              if (!m.src || (m.media_type && m.media_type !== 'image')) return;
              var alt = m.alt || '';
              if (/^material:/i.test(alt)) return;            // skip fabric/material media
              if (/^variant:/i.test(alt)) variantImgs.push(m.src);
              else productImgs.push(m.src);                   // featured + gallery: + untagged = product level
            });
          }
          var drawerImages = productImgs.concat(variantImgs);
          if (drawerImages.length === 0 && imageUrl) drawerImages = [imageUrl];

          drawerImages.forEach(function (src, i) {
            var img = document.createElement('img');
            img.src = src; img.alt = title + ' ' + (i + 1); img.loading = i === 0 ? 'eager' : 'lazy';
            track.appendChild(img);
          });
        }
      })
      .catch(function (err) { log('[Drawer] Failed to fetch product:', err); if (descEl && !manualDescription) descEl.innerHTML = ''; });

    var step1Footer = document.getElementById('step1-footer');
    if (step1Footer) step1Footer.style.display = 'none';

    overlay.style.display = 'block';
    drawer.style.display = 'block';
    requestAnimationFrame(function () { drawer.classList.add('open'); });
    updateBottomBar(1, true);
    drawer.dataset.sizeGuideImage = sizeGuideImage || '';
    updateScrollIndicator();
    // Scroll up so the drawer's product text is in view even if scrolled down the grid
    var configurator = document.getElementById('product-configurator');
    if (configurator) configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function closeProductDrawer() {
    var drawer = document.getElementById('product-detail-drawer');
    var overlay = document.getElementById('product-drawer-overlay');
    var wasHelp = drawer && drawer.dataset.isHelp === 'true';
    if (drawer) { drawer.classList.remove('open'); drawer.dataset.isHelp = ''; setTimeout(function () { drawer.style.display = 'none'; }, 300); }
    if (overlay) overlay.style.display = 'none';
    drawerOpen = false;
    document.querySelectorAll('.product-card').forEach(function (card) { card.classList.remove('selected'); });
    if (!wasHelp) hideBottomBar();
    updateStep1Footer();
  }

  function openHelpDrawer() {
    var drawer = document.getElementById('product-detail-drawer');
    var overlay = document.getElementById('product-drawer-overlay');
    var titleEl = document.getElementById('drawer-product-title');
    var descEl = document.getElementById('drawer-product-description');
    var galleryEl = document.getElementById('drawer-gallery');
    if (!drawer) return;
    drawer.dataset.isHelp = 'true';
    if (titleEl) titleEl.textContent = config.helpDrawerTitle || 'Help';
    // Intro text now lives behind the "?" — fall back to the step-1 copy block.
    if (descEl) descEl.innerHTML = config.helpDrawerContent || config.step1CopyBlock || '';
    // Help has no subtitle / lookbook link
    var helpSubtitle = document.getElementById('drawer-product-subtitle');
    if (helpSubtitle) helpSubtitle.style.display = 'none';
    var helpLookbook = document.getElementById('drawer-lookbook-link');
    if (helpLookbook) helpLookbook.style.display = 'none';
    if (galleryEl) {
      var track = galleryEl.querySelector('.drawer-gallery-track');
      if (track) track.innerHTML = '';
    }
    var step1Footer = document.getElementById('step1-footer');
    if (step1Footer) step1Footer.style.display = 'none';
    overlay.style.display = 'block';
    drawer.style.display = 'block';
    requestAnimationFrame(function () { drawer.classList.add('open'); });
    // Scroll the configurator up so the (top-anchored) help sidebar is visible
    var configurator = document.getElementById('product-configurator');
    if (configurator) configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function confirmProductAndGoToStep2() {
    var drawer = document.getElementById('product-detail-drawer');
    var overlay = document.getElementById('product-drawer-overlay');
    if (drawer) { drawer.classList.remove('open'); drawer.style.display = 'none'; }
    if (overlay) overlay.style.display = 'none';
    drawerOpen = false;
    var sizeGuideImage = drawer ? drawer.dataset.sizeGuideImage || null : null;
    selectProductType(selectedProductHandle, selectedProductId, selectedProductTitle, selectedProductImageUrl, sizeGuideImage);
  }

  // ===== Memory management =====
  function cacheProductData(productId, data) {
    if (!productId) return;
    if (productDataLRU.size >= MAX_PRODUCT_CACHE_SIZE) {
      var oldest = productDataLRU.keys().next().value;
      productDataLRU.delete(oldest);
      log('[Memory] Evicted oldest product from cache:', oldest);
    }
    productDataLRU.set(productId, Object.assign({}, data, { cachedAt: Date.now() }));
    log('[Memory] Cached product data:', productId, '(' + productDataLRU.size + '/' + MAX_PRODUCT_CACHE_SIZE + ')');
  }

  function getCachedProductData(productId) {
    if (!productId) return null;
    var cached = productDataLRU.get(productId);
    if (cached) { log('[Memory] Using cached product data:', productId); return cached; }
    return null;
  }

  // ===== Cleanup =====
  function cleanupGalleryListeners() {
    galleryAbortControllers.forEach(function (c) { try { c.abort(); } catch (e) {} });
    galleryAbortControllers = [];
  }

  function cleanupIntersectionObserver() {
    if (cardObserver) { cardObserver.disconnect(); cardObserver = null; }
  }

  function clearProductData() {
    variants = [];
    fabricMetafields = {};
    productSizeGuideImage = null;
    selectedFabric = '';
    selectedSize = '';
    selectedVariant = null;
    selectedProductPrice = 0;
  }

  function cleanupAllResources() {
    cleanupGalleryListeners();
    cleanupIntersectionObserver();
    clearProductData();
  }

  // Tab-visibility VRAM cleanup
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      cleanupGalleryListeners();
      var largeImages = document.querySelectorAll('#fabric-main-image, #size-variant-image, .gallery-main img');
      largeImages.forEach(function (img) {
        img.dataset.restoreSrc = img.src;
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        img.removeAttribute('srcset');
      });
    } else {
      // Restore the images we blanked when the tab was hidden.
      var restoreImages = document.querySelectorAll('#fabric-main-image, #size-variant-image, .gallery-main img');
      restoreImages.forEach(function (img) {
        if (img.dataset.restoreSrc) { img.src = img.dataset.restoreSrc; delete img.dataset.restoreSrc; }
      });
      if (selectedFabric) selectFabric(selectedFabric);
    }
  });

  // ===== Utility =====
  function debounce(func, wait, key) {
    return function () {
      var args = arguments;
      var later = function () { clearTimeout(debounceTimers[key]); func.apply(null, args); };
      clearTimeout(debounceTimers[key]);
      debounceTimers[key] = setTimeout(later, wait);
    };
  }

  // ===== URL parameter management =====
  function getURLParams() {
    var params = new URLSearchParams(window.location.search);
    return { product: params.get('product'), material: params.get('material'), size: params.get('size') };
  }

  function updateURL(step, replace) {
    var url = new URL(window.location.href);
    url.hash = '#step-' + step;
    if (selectedProductHandle) url.searchParams.set('product', selectedProductHandle); else url.searchParams.delete('product');
    if (selectedFabric) url.searchParams.set('material', selectedFabric); else url.searchParams.delete('material');
    if (selectedSize) url.searchParams.set('size', selectedSize); else url.searchParams.delete('size');
    var state = { step: step, product: selectedProductHandle, material: selectedFabric, size: selectedSize };
    if (replace) history.replaceState(state, '', url.toString());
    else history.pushState(state, '', url.toString());
    log('[URL] Updated:', url.toString());
  }

  // ===== Tab switching =====
  function switchTab(tabName) {
    document.querySelectorAll('.tab-button').forEach(function (b) { b.classList.remove('active'); });
    document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
    var btn = document.querySelector('.tab-button[data-tab="' + tabName + '"]');
    if (btn) btn.classList.add('active');
    var panel = document.querySelector('.tab-panel[data-tab="' + tabName + '"]');
    if (panel) panel.classList.add('active');
  }

  function updateFabricTabs(fabric) {
    log('[Tab Update] Updating tabs for fabric:', fabric);
    var materialsPanel = document.querySelector('.tab-panel[data-tab="materials"]');
    var maintenancePanel = document.querySelector('.tab-panel[data-tab="maintenance"]');
    if (!materialsPanel || !maintenancePanel) return;

    var meta = fabricMetafields[fabric];
    if (meta) {
      if (meta.materials) {
        materialsPanel.innerHTML = sanitizeHTML(meta.materials, {
          ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'li', 'ol', 'table', 'tr', 'td', 'th', 'tbody', 'thead'],
          ALLOWED_ATTR: []
        });
      } else {
        materialsPanel.innerHTML = config.materialsTabContent || '';
      }
      if (meta.maintenance) {
        maintenancePanel.innerHTML = sanitizeHTML(meta.maintenance, {
          ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'li', 'ol', 'table', 'tr', 'td', 'th', 'tbody', 'thead'],
          ALLOWED_ATTR: []
        });
      } else {
        maintenancePanel.innerHTML = config.maintenanceTabContent || '';
      }
    } else {
      materialsPanel.innerHTML = config.materialsTabContent || '';
      maintenancePanel.innerHTML = config.maintenanceTabContent || '';
    }
  }

  // ===== Browser back/forward =====
  window.addEventListener('popstate', async function (event) {
    var match = window.location.hash.match(/#step-(\d+)/);
    var step = match ? parseInt(match[1], 10) : (event.state && event.state.step !== undefined ? event.state.step : 1);
    var urlParams = getURLParams();

    if (urlParams.product && urlParams.product !== selectedProductHandle) {
      var productCard = document.querySelector('.product-card[data-product-handle="' + urlParams.product + '"]');
      if (productCard) {
        await selectProductType(
          urlParams.product,
          productCard.getAttribute('data-product-id'),
          productCard.getAttribute('data-product-title'),
          productCard.getAttribute('data-product-image'),
          productCard.getAttribute('data-size-guide-image')
        );
      }
    }
    if (urlParams.material && urlParams.material !== selectedFabric && step >= 2) {
      selectFabric(urlParams.material);
    }
    if (urlParams.size && urlParams.size !== selectedSize && step >= 3) {
      selectSize(urlParams.size);
    }

    document.querySelectorAll('.step').forEach(function (el) { el.classList.remove('active'); });
    var target = document.getElementById('step-' + step);
    if (target) target.classList.add('active');
    var nav = document.getElementById('steps-nav');
    if (nav) { nav.style.display = step > 0 ? 'flex' : 'none'; updateBreadcrumb(step); }
    updateStepIndicatorPill(step);
    updateStep1Footer();
    if (step === 3) updateAvailableSizes();
  });

  // ===== Richtext AST parser =====
  function parseRichtextAST(ast) {
    if (!ast || typeof ast !== 'object') return '';
    function parseNode(node) {
      if (!node) return '';
      if (node.type === 'text') return node.value || '';
      if (node.children && Array.isArray(node.children)) {
        var childrenHTML = node.children.map(parseNode).join('');
        switch (node.type) {
          case 'paragraph': return '<p>' + childrenHTML + '</p>';
          case 'heading': var lvl = node.level || 2; return '<h' + lvl + '>' + childrenHTML + '</h' + lvl + '>';
          case 'list': var tag = node.listType === 'ordered' ? 'ol' : 'ul'; return '<' + tag + '>' + childrenHTML + '</' + tag + '>';
          case 'list-item': return '<li>' + childrenHTML + '</li>';
          case 'link': return '<a href="' + (node.url || '#') + '">' + childrenHTML + '</a>';
          case 'bold': return '<strong>' + childrenHTML + '</strong>';
          case 'italic': return '<em>' + childrenHTML + '</em>';
          case 'root': return childrenHTML;
          default: return childrenHTML;
        }
      }
      return '';
    }
    return parseNode(ast);
  }

  // ===== Product selection =====
  async function selectProductType(handle, productId, title, imageUrl, preloadedSizeGuideImage) {
    log('[Product Selection] Called with:', { handle: handle, productId: productId, title: title });

    if (selectedProductId && selectedProductId !== productId) {
      cleanupGalleryListeners();
      clearProductData();
    }

    selectedProductHandle = handle;
    selectedProductId = productId;
    selectedProductTitle = title;
    productSizeGuideImage = preloadedSizeGuideImage || null;

    var selectedCard = document.querySelector('.product-card[data-product-id="' + productId + '"]');
    if (selectedCard) { selectedCard.style.opacity = '0.6'; selectedCard.style.pointerEvents = 'none'; }
    document.querySelectorAll('.product-card').forEach(function (card) { card.classList.remove('selected'); });
    if (selectedCard) selectedCard.classList.add('selected');
    document.getElementById('type-error').style.display = 'none';

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, 10000);

    try {
      var response = await fetch('/products/' + handle + '.js', { signal: controller.signal });
      clearTimeout(timeoutId);
      if (!response.ok) throw new Error('Failed to fetch product: ' + response.status);
      var product = await response.json();
      log('[Product Selection] Product data received');

      // Parse compressed fabric metafields from server (embedded on the card)
      var fabricMetafieldsData = selectedCard ? selectedCard.getAttribute('data-fabric-metafields') : null;
      var fabricMetafieldsFromServer = [];
      try { fabricMetafieldsFromServer = fabricMetafieldsData ? JSON.parse(fabricMetafieldsData) : []; }
      catch (err) { log('[Metafields] Error parsing:', err); }

      // Products loaded via a collection's configurator_products metafield reference don't
      // expose nested variant metafields, so big products embed 0 fabrics. Fall back to a
      // dedicated per-product template where the product is the main resource.
      if (fabricMetafieldsFromServer.length === 0) {
        try {
          var fdResp = await fetch('/products/' + handle + '?view=fabricdata', { signal: controller.signal });
          if (fdResp.ok) {
            var fdText = decodeHTMLEntities((await fdResp.text()).trim());
            if (fdText) fabricMetafieldsFromServer = JSON.parse(fdText);
          }
        } catch (fdErr) { log('[Metafields] fabricdata fetch failed:', fdErr); }
      }

      variants = product.variants;
      selectedProductPrice = product.price;

      // Update step 2 product info
      // Heading is the configurable step-2 phrase + selected fabric (set in selectFabric),
      // so we intentionally do not overwrite it with the product title here.
      // The subtitle (#fabric-product-description) shows the selected material's
      // description (not the product description) and is set per-fabric in selectFabric.
      var fabricPriceEl = document.getElementById('fabric-product-price');
      if (fabricPriceEl && product.price) {
        fabricPriceEl.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency', currency: product.variants[0].currency || 'EUR'
        }).format(product.price / 100);
      }

      // Check LRU cache
      var cachedData = getCachedProductData(product.id);
      if (cachedData) {
        fabricGalleries = cachedData.fabricGalleries || {};
        fabricMetafields = cachedData.fabricMetafields || {};
        if (!preloadedSizeGuideImage) productSizeGuideImage = cachedData.productSizeGuideImage || null;
      } else {
        // Build fresh data
        if (!preloadedSizeGuideImage) productSizeGuideImage = null;

        // Scan product.media only for Size Guide images
        if (product.media && Array.isArray(product.media)) {
          product.media.forEach(function (image) {
            if (!image.src || (image.media_type && image.media_type !== 'image')) return;
            if (image.alt && (image.alt === 'Size Guide' || image.alt.indexOf('Size Guide:') !== -1)) {
              productSizeGuideImage = image.src;
            }
          });
        }

        fabricGalleries = {};

        // Build fabric metafields from compressed server data
        fabricMetafields = {};
        var uniqueFabrics = new Set();
        variants.forEach(function (variant) {
          if (variant.option2 && !uniqueFabrics.has(variant.option2)) {
            uniqueFabrics.add(variant.option2);
            fabricMetafields[variant.option2] = { materials: '', maintenance: '', description: '' };
          }
        });

        if (fabricMetafieldsFromServer.length > 0) {
          fabricMetafieldsFromServer.forEach(function (item) {
            var fabricName = item.f;
            var materialsInfo = item.m || '';
            var maintenanceInfo = item.n || '';
            if (typeof materialsInfo === 'object' && materialsInfo !== null) materialsInfo = parseRichtextAST(materialsInfo);
            if (typeof maintenanceInfo === 'object' && maintenanceInfo !== null) maintenanceInfo = parseRichtextAST(maintenanceInfo);
            if (fabricMetafields[fabricName]) {
              fabricMetafields[fabricName] = {
                materials: materialsInfo,
                maintenance: maintenanceInfo,
                description: item.d || '',
                swatch: item.s || '',
                gallery: item.g || []
              };
            }
          });
        }

        cacheProductData(product.id, { fabricGalleries: fabricGalleries, fabricMetafields: fabricMetafields, productSizeGuideImage: productSizeGuideImage });
      }

      populateFabricOptions();
      if (selectedCard) { selectedCard.style.opacity = ''; selectedCard.style.pointerEvents = ''; }
      nextStep(2);

    } catch (error) {
      if (selectedCard) { selectedCard.style.opacity = ''; selectedCard.style.pointerEvents = ''; }
      if (error.name === 'AbortError') {
        alert('De aanvraag duurde te lang. Probeer het opnieuw.');
      } else {
        log('[Product Selection] Error:', error);
        alert('Er is een fout opgetreden bij het laden van het product. Probeer het opnieuw.');
      }
    }
  }

  // ===== Fabric options =====
  function populateFabricOptions() {
    var container = document.querySelector('.fabric-options');
    container.innerHTML = '';
    var seen = new Set();
    var fabricData = [];

    variants.forEach(function (variant) {
      if (variant.available && variant.option2 && !seen.has(variant.option2)) {
        seen.add(variant.option2);
        var imgSrc = '';
        // Tier 1: swatch from metafield (material_image)
        if (fabricMetafields[variant.option2] && fabricMetafields[variant.option2].swatch) {
          imgSrc = shopifyImageUrl(fabricMetafields[variant.option2].swatch, 'small');
        }
        // Tier 2: variant featured image
        if (!imgSrc && variant.featured_image && variant.featured_image.src) {
          imgSrc = shopifyImageUrl(variant.featured_image.src, 'small');
        }
        // Tier 3: product main image
        if (!imgSrc) {
          var card = document.querySelector('.product-card[data-product-id="' + selectedProductId + '"]');
          var mainImg = card ? card.getAttribute('data-product-image') : '';
          if (mainImg) imgSrc = shopifyImageUrl(mainImg, 'small');
        }
        fabricData.push({ name: variant.option2, imgSrc: imgSrc });
      }
    });

    var fragment = document.createDocumentFragment();
    fabricData.forEach(function (fabric) {
      var swatch = document.createElement('div');
      swatch.className = 'fabric-swatch';
      swatch.setAttribute('data-fabric', fabric.name);
      swatch.setAttribute('data-fabric-name', fabric.name);
      swatch.onclick = function () { selectFabric(fabric.name); };
      var img = document.createElement('img');
      if (!fabric.imgSrc) {
        img.src = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"><rect width="64" height="64" fill="#ddd"/></svg>');
      } else {
        img.src = fabric.imgSrc;
      }
      img.alt = fabric.name;
      swatch.appendChild(img);
      fragment.appendChild(swatch);
    });
    container.appendChild(fragment);

    if (fabricData.length > 0) selectFabric(fabricData[0].name);
    // Recompute scroll-arrow visibility now that swatches exist
    updateFabricArrows();
    setTimeout(updateFabricArrows, 100);
  }

  // ===== Navigation helpers =====
  function getCurrentStep() {
    var active = document.querySelector('.step.active');
    if (active) return parseInt(active.id.split('-')[1]);
    return 1;
  }

  function navigateToStep(step) {
    if (step === 1) prevStep(1);
    else if (step === 2 && selectedProductHandle) prevStep(2);
    else if (step === 3 && selectedFabric) nextStep(3);
  }

  function nextStep(step) {
    document.querySelectorAll('.error-message').forEach(function (el) { el.style.display = 'none'; });
    if (step === 3 && !selectedFabric) { document.getElementById('fabric-error').style.display = 'block'; return; }
    document.querySelectorAll('.step').forEach(function (el) { el.classList.remove('active'); });
    document.getElementById('step-' + step).classList.add('active');
    var nav = document.getElementById('steps-nav');
    if (nav) { nav.style.display = step > 0 ? 'flex' : 'none'; updateBreadcrumb(step); }
    if (step === 3) updateAvailableSizes();
    updateURL(step);
    updateBottomBar(step);
    updateStep1Footer();
    // #38 — reset scroll to the top of the configurator so advancing from a
    // far-scrolled step 1 doesn't leave the next step mis-positioned.
    if (step >= 2) {
      var cfg = document.getElementById('product-configurator');
      if (cfg) cfg.scrollIntoView({ block: 'start' });
    }
    // The fabric row only has a measurable width once step 2 is visible
    if (step === 2) { updateFabricArrows(); setTimeout(updateFabricArrows, 80); }
  }

  function prevStep(step) {
    document.querySelectorAll('.step').forEach(function (el) { el.classList.remove('active'); });
    document.getElementById('step-' + step).classList.add('active');
    var nav = document.getElementById('steps-nav');
    if (nav) { nav.style.display = step > 0 ? 'flex' : 'none'; updateBreadcrumb(step); }
    if (step === 1) { cleanupAllResources(); selectedFabric = null; selectedSize = null; hideBottomBar(); }
    else if (step === 2) { selectedSize = null; updateBottomBar(2); }
    updateURL(step);
    updateStep1Footer();
  }

  // ===== Size selection =====
  function selectSize(size) {
    var sizeButton = document.querySelector('button[data-size="' + size + '"]');
    if (!sizeButton) return;
    if (sizeButton.getAttribute('data-available') !== 'true') {
      document.getElementById('size-error').textContent = 'Deze maat is niet beschikbaar in de geselecteerde stof';
      document.getElementById('size-error').style.display = 'block';
      return;
    }
    document.getElementById('size-error').style.display = 'none';
    selectedSize = size;
    document.querySelectorAll('.size-options .btn').forEach(function (btn) { btn.classList.remove('selected'); });
    sizeButton.classList.add('selected');
    updateVariantInfo();
    updateStockInfo();
    if (getCurrentStep() === 3) updateBottomBar(3);
    updateURL(getCurrentStep(), false);
  }

  function updateVariantInfo() {
    selectedVariant = variants.find(function (v) { return v.option1 === selectedSize && v.option2 === selectedFabric; });
    if (selectedVariant) {
      // The step-3 gallery (rendered per fabric) owns the main image; only fall back to a
      // single variant image when the fabric has no gallery at all.
      var variantImage = getFabricGalleryItems(selectedFabric).length === 0
        ? document.getElementById('size-variant-image')
        : null;
      if (variantImage) {
        if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
          variantImage.src = selectedVariant.featured_image.src;
        } else {
          var fabricVariant = variants.find(function (v) { return v.option2 === selectedFabric && v.featured_image; });
          if (fabricVariant && fabricVariant.featured_image.src) {
            variantImage.src = fabricVariant.featured_image.src;
          } else {
            var card = document.querySelector('.product-card[data-product-id="' + selectedProductId + '"]');
            var mainImg = card ? card.getAttribute('data-product-image') : '';
            if (mainImg) variantImage.src = mainImg;
          }
        }
      }
      var outOfStockEl = document.getElementById('out-of-stock');
      if (outOfStockEl) outOfStockEl.style.display = selectedVariant.available ? 'none' : 'block';
    }
  }

  function updateStockInfo() {
    var el = document.getElementById('stock-info');
    if (!el) return;
    if (selectedSize && selectedFabric) {
      var variant = variants.find(function (v) { return v.option1 === selectedSize && v.option2 === selectedFabric; });
      if (variant && variant.inventory_quantity !== undefined) {
        el.textContent = variant.inventory_quantity + ' op voorraad';
        el.style.display = 'block';
      } else if (variant && variant.available) {
        el.textContent = 'Op voorraad';
        el.style.display = 'block';
      } else { el.style.display = 'none'; }
    } else { el.style.display = 'none'; }
  }

  // ===== Size guide & image zoom =====
  var sizeGuideContentLoaded = false;

  function showSizeGuideImageFallback() {
    var img = document.getElementById('size-guide-image');
    var contentEl = document.getElementById('size-guide-content');
    if (contentEl) contentEl.style.display = 'none';
    if (img) {
      img.style.display = '';
      if (productSizeGuideImage) img.src = productSizeGuideImage;
      else { var def = img.getAttribute('data-default-src'); if (def) img.src = def; }
    }
  }

  // #41 — load the /pages/maattabel content into the popup (single source of truth),
  // falling back to the configured image when the page can't be fetched/parsed.
  function loadSizeGuideContent() {
    var contentEl = document.getElementById('size-guide-content');
    var pageUrl = config.sizeGuidePageUrl || '/pages/maattabel';
    if (!contentEl || !pageUrl) { showSizeGuideImageFallback(); return; }
    if (sizeGuideContentLoaded) { contentEl.style.display = 'block'; return; }
    fetch(pageUrl, { signal: AbortSignal.timeout(10000) })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[id^="MainContent"]') || doc.querySelector('main') || doc.querySelector('.rte');
        if (!node || !node.innerHTML.trim()) { showSizeGuideImageFallback(); return; }
        contentEl.innerHTML = sanitizeHTML(node.innerHTML, {
          ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'b', 'i', 'u', 'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'img', 'span', 'div'],
          ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'colspan', 'rowspan']
        });
        contentEl.style.display = 'block';
        var img = document.getElementById('size-guide-image');
        if (img) img.style.display = 'none';
        sizeGuideContentLoaded = true;
      })
      .catch(function () { showSizeGuideImageFallback(); });
  }

  function openSizeGuide() {
    var modal = document.getElementById('size-guide-modal');
    if (!modal) return;
    loadSizeGuideContent();
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleEscapeKey);
  }

  function closeSizeGuide() {
    var modal = document.getElementById('size-guide-modal');
    if (modal) { modal.classList.remove('active'); document.body.style.overflow = ''; document.removeEventListener('keydown', handleEscapeKey); }
  }

  function openImageZoom(imageSrc) {
    var modal = document.getElementById('image-zoom-modal');
    var zoomImg = document.getElementById('image-zoom-img');
    if (modal && zoomImg && imageSrc) {
      // Use the clean/original URL (no size suffix). Don't append "_master": gallery media
      // are uploaded as Shopify "files", which have no _master variant (it 404s).
      zoomImg.src = shopifyImageUrl(imageSrc);
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleImageZoomEscapeKey);
    }
  }

  function closeImageZoom() {
    var modal = document.getElementById('image-zoom-modal');
    if (modal) { modal.classList.remove('active'); document.body.style.overflow = ''; document.removeEventListener('keydown', handleImageZoomEscapeKey); }
  }

  function handleImageZoomEscapeKey(event) { if (event.key === 'Escape') closeImageZoom(); }
  function handleEscapeKey(event) { if (event.key === 'Escape') closeSizeGuide(); }

  // ===== Fabric selection =====
  function selectFabric(fabric) {
    try {
      if (!fabric || typeof fabric !== 'string') return;
      if (!variants || !Array.isArray(variants) || variants.length === 0) {
        alert('Geen varianten beschikbaar. Ververs de pagina.');
        return;
      }

      selectedFabric = fabric;
      updateBottomBar(2);

      document.querySelectorAll('.fabric-swatch').forEach(function (s) { s.classList.remove('selected'); });
      var selectedSwatch = document.querySelector('.fabric-swatch[data-fabric="' + fabric + '"]');
      if (!selectedSwatch) return;
      selectedSwatch.classList.add('selected');

      var fabricName = selectedSwatch.getAttribute('data-fabric-name');
      var fabricLabel = document.getElementById('fabric-label');
      if (fabricLabel) fabricLabel.textContent = fabricName;
      var titleEl = document.getElementById('fabric-product-title');
      if (titleEl && titleEl.dataset.heading) {
        titleEl.textContent = fabricName ? (titleEl.dataset.heading + ' / ' + fabricName) : titleEl.dataset.heading;
      }

      // Subtitle = the selected material's description (from pragma's custom.material_description),
      // NOT the product description.
      var fabricDescEl = document.getElementById('fabric-product-description');
      if (fabricDescEl) {
        var meta = fabricMetafields[fabric];
        var materialDesc = meta && meta.description ? meta.description : '';
        var cleanDesc = sanitizeHTML(materialDesc, {
          ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'li', 'ol', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
          ALLOWED_ATTR: ['href', 'target', 'rel']
        });
        applyReadMoreFunctionality(fabricDescEl, cleanDesc);
      }

      updateStep3Heading();

      // Update main image from swatch
      var mainImage = document.getElementById('fabric-main-image');
      if (mainImage && selectedSwatch) {
        var swatchImg = selectedSwatch.querySelector('img');
        if (swatchImg && swatchImg.src) {
          mainImage.style.backgroundImage = "url('" + swatchImg.src + "')";
          mainImage.style.backgroundSize = 'contain';
          mainImage.style.backgroundRepeat = 'no-repeat';
          mainImage.style.backgroundPosition = 'center';
          var targetSrc = shopifyImageUrl(swatchImg.src, '1024x1024');
          var loader = new Image();
          loader.onload = function () { mainImage.src = targetSrc; mainImage.style.backgroundImage = 'none'; };
          loader.onerror = function () { mainImage.src = shopifyImageUrl(swatchImg.src); mainImage.style.backgroundImage = 'none'; };
          loader.src = targetSrc;
        }
      }

      updateFabricTabs(fabric);

      var nextButton = document.getElementById('next-to-size');
      if (nextButton) { nextButton.classList.remove('disabled', 'btn-disabled'); nextButton.disabled = false; }

      renderFabricGalleries(fabric);
      updateAvailableSizes();
      updateURL(getCurrentStep(), false);
    } catch (error) {
      log('[selectFabric] Error:', error);
      alert('Er is een fout opgetreden bij het selecteren van de kleur. Ververs de pagina.');
    }
  }

  // ===== Dynamic size sorting =====
  function sortSizes(sizes) {
    var cacheKey = sizes.slice().sort().join(',');
    if (sizeSortingCache[cacheKey]) return sizeSortingCache[cacheKey];

    var sizeOrder = { 'XXS': 1, 'XS': 2, 'S': 3, 'M': 4, 'L': 5, 'XL': 6, 'XXL': 7, 'XXXL': 8 };
    var sorted = sizes.slice().sort(function (a, b) {
      if (sizeOrder[a] && sizeOrder[b]) return sizeOrder[a] - sizeOrder[b];
      if (sizeOrder[a]) return -1;
      if (sizeOrder[b]) return 1;
      var numA = parseFloat(a), numB = parseFloat(b);
      if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
      return a.localeCompare(b);
    });
    sizeSortingCache[cacheKey] = sorted;
    return sorted;
  }

  // ===== Available sizes (dynamic — no hardcoded array) =====
  function updateAvailableSizes() {
    updateStep3Heading();
    var currentSizeAvailable = variants.some(function (v) {
      return v.option1 === selectedSize && v.option2 === selectedFabric && v.available;
    });

    var container = document.querySelector('.size-options');
    container.innerHTML = '';

    // Derive all unique sizes for the selected fabric from variant data
    var sizeSet = new Set();
    variants.forEach(function (v) {
      if (v.option2 === selectedFabric && v.option1) sizeSet.add(v.option1);
    });
    // Also include sizes from other fabrics so the full size range shows (disabled if unavailable)
    variants.forEach(function (v) {
      if (v.option1) sizeSet.add(v.option1);
    });

    var allSizes = sortSizes(Array.from(sizeSet));

    var sizeAvailabilityMap = {};
    variants.forEach(function (v) {
      if (v.option2 === selectedFabric) sizeAvailabilityMap[v.option1] = v.available;
    });

    var availableSizes = [];
    var fragment = document.createDocumentFragment();
    allSizes.forEach(function (size) {
      var isAvailable = sizeAvailabilityMap[size] === true;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn-large' + (!isAvailable ? ' disabled' : '');
      btn.setAttribute('data-size', size);
      btn.setAttribute('data-available', isAvailable);

      if (isAvailable) {
        btn.textContent = size;
        btn.onclick = function () { selectSize(size); };
        availableSizes.push(size);
      } else {
        btn.appendChild(document.createTextNode(size));
        var tooltip = document.createElement('span');
        tooltip.className = 'tooltip-text';
        tooltip.textContent = 'kies een andere stof voor deze maat';
        btn.appendChild(tooltip);
      }
      fragment.appendChild(btn);
    });
    container.appendChild(fragment);

    if ((!selectedSize || !currentSizeAvailable) && availableSizes.length > 0) {
      var sorted = sortSizes(availableSizes);
      selectSize(sorted[0]);
    } else if (selectedSize && currentSizeAvailable) {
      selectSize(selectedSize);
    }
    updateStockInfo();
  }

  // ===== Add to cart =====
  // reconfigure=true → after adding, reset the configurator to step 1 instead of going to /cart
  function addToCart(reconfigure) {
    try {
      if (addToCartInProgress) return;
      if (!selectedSize || typeof selectedSize !== 'string') {
        document.getElementById('size-error').textContent = 'Gelieve een maat te selecteren';
        document.getElementById('size-error').style.display = 'block';
        return;
      }
      if (!selectedFabric || typeof selectedFabric !== 'string') {
        document.getElementById('size-error').textContent = 'Gelieve een stof te selecteren';
        document.getElementById('size-error').style.display = 'block';
        return;
      }
      updateVariantInfo();
      if (!selectedVariant || !selectedVariant.id) {
        document.getElementById('out-of-stock').style.display = 'block';
        return;
      }
      if (!selectedVariant.available) {
        document.getElementById('out-of-stock').style.display = 'block';
        return;
      }

      document.getElementById('size-error').style.display = 'none';
      document.getElementById('out-of-stock').style.display = 'none';
      addToCartInProgress = true;
      var addBtn = document.getElementById('add-to-cart');
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Toevoegen...'; }
      var barPrimaryBtn = document.getElementById('bar-btn-primary');
      if (barPrimaryBtn) { barPrimaryBtn.disabled = true; barPrimaryBtn.textContent = 'Toevoegen...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: selectedVariant.id, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (err) { throw new Error(err.description || err.message || 'Failed to add to cart'); });
          return response.json();
        })
        .then(function () {
          if (reconfigure) resetConfigurator();
          else window.location.href = '/cart';
        })
        .catch(function (error) {
          document.getElementById('size-error').textContent = error.message || 'Fout bij toevoegen aan winkelmandje. Probeer opnieuw.';
          document.getElementById('size-error').style.display = 'block';
          resetAddToCartButtons();
        });
    } catch (error) {
      log('[addToCart] Error:', error);
      document.getElementById('size-error').textContent = 'Er is een fout opgetreden. Ververs de pagina en probeer opnieuw.';
      document.getElementById('size-error').style.display = 'block';
      resetAddToCartButtons();
    }
  }

  function resetAddToCartButtons() {
    addToCartInProgress = false;
    var addBtn = document.getElementById('add-to-cart');
    if (addBtn) { addBtn.disabled = false; addBtn.textContent = config.addToCartButtonText || 'Naar winkelmandje'; }
    var barBtn = document.getElementById('bar-btn-primary');
    if (barBtn) { barBtn.disabled = false; barBtn.textContent = bottomBarSettings.step3Primary; }
  }

  // Add-to-cart-and-reconfigure: clear the selection and return to step 1 for a fresh build
  function resetConfigurator() {
    resetAddToCartButtons();
    selectedProductHandle = '';
    selectedProductId = null;
    selectedProductTitle = '';
    selectedProductPrice = 0;
    document.querySelectorAll('.product-card').forEach(function (c) {
      c.classList.remove('selected');
      c.style.opacity = '';
      c.style.pointerEvents = '';
    });
    prevStep(1);
    var configurator = document.getElementById('product-configurator');
    if (configurator) configurator.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ===== Breadcrumb =====
  function updateBreadcrumb(step) {
    var nav = document.getElementById('steps-nav');
    if (!nav) return;
    nav.querySelectorAll('.step-item').forEach(function (item) {
      item.classList.remove('active', 'completed', 'disabled');
      var itemStep = parseInt(item.getAttribute('data-step'));
      if (itemStep < step) item.classList.add('completed');
      if (itemStep === step) item.classList.add('active');
      if (itemStep > step) item.classList.add('disabled');
    });
    updateStepIndicatorPill(step);
  }

  function updateStepIndicatorPill(step) {
    var countEl = document.getElementById('current-step-text');
    if (countEl) countEl.textContent = 'Stap ' + step + ' van 3';
    var labelEl = document.getElementById('current-step-label');
    if (labelEl) {
      var navLabel = document.querySelector('.steps-nav .step-item[data-step="' + step + '"] .step-label');
      labelEl.textContent = navLabel ? navLabel.textContent : '';
    }
    document.querySelectorAll('.step-indicator-pill .step-progress-seg').forEach(function (seg) {
      seg.classList.toggle('active', parseInt(seg.getAttribute('data-step'), 10) <= step);
    });
    if (window.innerWidth <= 1024) {
      var pillContainer = document.querySelector('.step-indicator-pill');
      if (pillContainer) {
        setTimeout(function () {
          pillContainer.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }, 100);
      }
    }
  }

  // ===== Gallery =====
  // Resolve the ordered gallery items for a fabric (metafield gallery, with fallbacks).
  // Returns a fresh array so callers can reorder/filter without mutating the cache.
  function getFabricGalleryItems(fabric) {
    var galleryItems = ((fabricMetafields[fabric] && fabricMetafields[fabric].gallery) || []).slice();

    // Fallback: if no metafield gallery, use variant featured images
    if (galleryItems.length === 0) {
      variants.forEach(function (v) {
        if (v.option2 === fabric && v.featured_image && v.featured_image.src) {
          if (!galleryItems.find(function (g) { return g.url === v.featured_image.src; })) {
            galleryItems.push({ url: v.featured_image.src, type: 'image', origin: 'variant' });
          }
        }
      });
    }

    // Fallback 2: legacy fabricGalleries (material alt-text images)
    if (galleryItems.length === 0 && fabricGalleries[fabric]) {
      fabricGalleries[fabric].forEach(function (url) {
        galleryItems.push({ url: url, type: 'image', origin: 'material' });
      });
    }

    return galleryItems;
  }

  // Render a gallery (thumbnail column + main image) into a step's DOM.
  // Shared by step 2 and step 3 so both behave identically.
  function renderGalleryComponent(root, mainImg, fabric, galleryItems) {
    if (!root || !mainImg) return;
    var thumbsBox = root.querySelector('.gallery-thumbs');
    var mainContainer = root.querySelector('.gallery-main');
    var thumbsScroll = root.querySelector('.gallery-thumbs-scroll');
    if (!thumbsBox) return;

    // Set first image as main (keep the swatch image already set by selectFabric when none)
    var firstImage = galleryItems.find(function (g) { return g.type === 'image'; });
    if (firstImage) {
      mainImg.style.display = '';
      setMainImage(mainImg, firstImage.url);
    }
    if (mainContainer) {
      var existingPlayer = mainContainer.querySelector('.gallery-video-player');
      if (existingPlayer) existingPlayer.remove();
    }

    // Keep the thumbnail column visible to match the design: real thumbnails when the
    // fabric has 2+ gallery items, otherwise placeholder squares.
    thumbsBox.innerHTML = '';
    thumbsBox.classList.add('has-items');
    if (thumbsScroll) {
      thumbsScroll.classList.add('visible');
      // Grey the arrow out when there are only placeholder squares (no real images)
      thumbsScroll.classList.toggle('is-empty', galleryItems.length < 2);
    }

    if (galleryItems.length < 2) {
      var phFrag = document.createDocumentFragment();
      for (var ph = 0; ph < 6; ph++) {
        var placeholder = document.createElement('span');
        placeholder.className = 'gallery-thumb-placeholder';
        phFrag.appendChild(placeholder);
      }
      thumbsBox.appendChild(phFrag);
      return;
    }

    var fragment = document.createDocumentFragment();

    galleryItems.forEach(function (item, i) {
      if (item.type === 'image') {
        var thumb = document.createElement('img');
        thumb.src = shopifyImageUrl(item.url, 200);
        thumb.alt = fabric + ' view ' + (i + 1);
        thumb.loading = 'lazy';
        thumb.decoding = 'async';
        thumb.dataset.type = 'image';
        thumb.dataset.fullUrl = item.url;
        if (i === 0) thumb.classList.add('active');
        fragment.appendChild(thumb);
      } else if (item.type === 'video' || item.type === 'external_video') {
        var thumbWrap = document.createElement('div');
        thumbWrap.className = 'gallery-thumb-video';
        thumbWrap.dataset.type = 'video';
        thumbWrap.dataset.videoType = item.type;
        thumbWrap.dataset.host = item.host || '';
        thumbWrap.dataset.externalId = item.externalId || '';
        thumbWrap.dataset.videoSrc = item.url || '';
        if (item.thumbnail) {
          var vThumb = document.createElement('img');
          vThumb.src = shopifyImageUrl(item.thumbnail, 200);
          vThumb.alt = 'Video';
          vThumb.loading = 'lazy';
          thumbWrap.appendChild(vThumb);
        }
        var playIcon = document.createElement('span');
        playIcon.className = 'gallery-play-icon';
        playIcon.textContent = '\u25B6';
        thumbWrap.appendChild(playIcon);
        fragment.appendChild(thumbWrap);
      }
    });

    thumbsBox.appendChild(fragment);

    var controller = new AbortController();
    galleryAbortControllers.push(controller);
    thumbsBox.addEventListener('click', function (e) {
      var target = e.target.closest('[data-type]');
      if (!target) return;
      thumbsBox.querySelectorAll('img, .gallery-thumb-video').forEach(function (t) { t.classList.remove('active'); });
      target.classList.add('active');

      if (target.dataset.type === 'image') {
        showGalleryImage(mainContainer || mainImg.parentElement, target.dataset.fullUrl);
      } else if (target.dataset.type === 'video') {
        showGalleryVideo(mainContainer || mainImg.parentElement, target.dataset);
      }
    }, { signal: controller.signal });
  }

  // Render the step-2 and step-3 galleries for the selected fabric.
  // Step 2 keeps the stored order (material images first); step 3 shows the same
  // gallery but with variant renders first, then material images.
  function renderFabricGalleries(fabric) {
    cleanupGalleryListeners();

    var items = getFabricGalleryItems(fabric);
    renderGalleryComponent(document.getElementById('step-2'), document.getElementById('fabric-main-image'), fabric, items);

    var step3Items = getFabricGalleryItems(fabric);
    var variantItems = step3Items.filter(function (it) { return it.origin !== 'material'; });
    var materialItems = step3Items.filter(function (it) { return it.origin === 'material'; });
    renderGalleryComponent(document.getElementById('step-3'), document.getElementById('size-variant-image'), fabric, variantItems.concat(materialItems));
  }

  // Main gallery image: display width ≈ half the viewport, so request ~1200px
  // (with a srcset for smaller/denser screens) instead of the full-size original.
  function setMainImage(img, url) {
    img.src = shopifyImageUrl(url, 1200);
    var srcset = imageSrcset(url, [800, 1200, 1600]);
    if (srcset) {
      img.srcset = srcset;
      img.sizes = '(max-width: 768px) 100vw, 50vw';
    } else {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }
    img.dataset.zoomUrl = url;
  }

  function showGalleryImage(container, src) {
    var img = container.querySelector('#fabric-main-image, #size-variant-image');
    var player = container.querySelector('.gallery-video-player');
    if (player) player.remove();
    if (img) { img.style.display = ''; setMainImage(img, src); }
  }

  function showGalleryVideo(container, data) {
    var img = container.querySelector('#fabric-main-image, #size-variant-image');
    if (img) img.style.display = 'none';
    var existing = container.querySelector('.gallery-video-player');
    if (existing) existing.remove();

    var player = document.createElement('div');
    player.className = 'gallery-video-player';

    if (data.videoType === 'external_video' && data.host === 'gdrive' && data.externalId) {
      // Public Google Drive video — embed the /preview player (Shopify can't host these).
      var iframe = document.createElement('iframe');
      iframe.src = 'https://drive.google.com/file/d/' + data.externalId + '/preview';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay');
      player.appendChild(iframe);
    } else if (data.videoType === 'external_video' && data.host === 'youtube' && data.externalId) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + data.externalId;
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      player.appendChild(iframe);
    } else if (data.videoType === 'external_video' && data.host === 'vimeo' && data.externalId) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://player.vimeo.com/video/' + data.externalId;
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      player.appendChild(iframe);
    } else if (data.videoSrc) {
      var video = document.createElement('video');
      video.src = data.videoSrc;
      video.controls = true;
      player.appendChild(video);
    }
    container.appendChild(player);
  }

  // ===== Deep-link restoration (async, no setTimeout chains) =====
  async function restoreFromURL(urlParams, targetStep) {
    if (!urlParams.product) return;

    var productCard = document.querySelector('.product-card[data-product-handle="' + urlParams.product + '"]');
    if (!productCard) return;

    // Highlight and reorder
    productCard.classList.add('url-highlighted');
    var productGrid = productCard.parentElement;
    if (productGrid && productGrid.classList.contains('product-grid')) {
      productGrid.insertBefore(productCard, productGrid.firstChild);
    }

    if (targetStep >= 2 || targetStep === 1) {
      await selectProductType(
        urlParams.product,
        productCard.getAttribute('data-product-id'),
        productCard.getAttribute('data-product-title'),
        productCard.getAttribute('data-product-image'),
        productCard.getAttribute('data-size-guide-image')
      );
    }

    if (urlParams.material && targetStep >= 2) {
      var swatch = document.querySelector('.fabric-swatch[data-fabric="' + urlParams.material + '"]');
      if (swatch) selectFabric(urlParams.material);
    }

    if (urlParams.size && targetStep >= 3) {
      var sizeBtn = document.querySelector('button[data-size="' + urlParams.size + '"]');
      if (sizeBtn && sizeBtn.getAttribute('data-available') === 'true') selectSize(urlParams.size);
    }
  }

  // ===== Step 1 scroll-down indicator =====
  // Shows a bouncing chevron when more designs sit below the fold on step 1.
  function updateScrollIndicator() {
    var arrow = document.getElementById('step1-scroll-down');
    if (!arrow) return;
    var step1 = document.getElementById('step-1');
    var onStep1 = step1 && step1.classList.contains('active');
    var remaining = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
    if (onStep1 && !drawerOpen && remaining > 120) arrow.classList.add('visible');
    else arrow.classList.remove('visible');
  }

  function scrollDownOneView() {
    window.scrollBy({ top: Math.round(window.innerHeight * 0.8), behavior: 'smooth' });
  }

  // Footer lives outside #step-1, so its visibility is driven explicitly.
  function updateStep1Footer() {
    var footer = document.getElementById('step1-footer');
    if (!footer) return;
    var step1 = document.getElementById('step-1');
    var onStep1 = step1 && step1.classList.contains('active');
    footer.style.display = (onStep1 && !drawerOpen) ? 'flex' : 'none';
    updateScrollIndicator();
  }

  // Show/hide the step-2 fabric row scroll arrows based on scroll position + overflow.
  function updateFabricArrows() {
    var row = document.querySelector('#step-2 .fabric-options');
    if (!row) return;
    var prev = document.querySelector('.fabric-scroll-prev');
    var next = document.querySelector('.fabric-scroll-next');
    var atStart = row.scrollLeft <= 2;
    var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
    if (prev) prev.hidden = atStart;
    if (next) next.hidden = atEnd;
  }

  // Step 3 heading: "Jouw {product} {fabric}"
  function updateStep3Heading() {
    var el = document.getElementById('size-step-title');
    if (!el) return;
    var prefix = el.dataset.prefix || 'Jouw';
    var parts = [selectedProductTitle, selectedFabric].filter(Boolean);
    el.textContent = parts.length ? (prefix + ' ' + parts.join(' ')) : prefix;
  }

  // ===== Init =====
  document.addEventListener('DOMContentLoaded', function () {
    log('[Init] DOMContentLoaded');

    var nextToSizeBtn = document.getElementById('next-to-size');
    if (nextToSizeBtn) nextToSizeBtn.classList.add('disabled');

    // Setup product cards
    var productCards = document.querySelectorAll('.product-card');
    cleanupIntersectionObserver();

    function setupProductCard(card) {
      if (card.dataset.setupComplete === 'true') return;
      var handle = card.getAttribute('data-product-handle');
      var id = card.getAttribute('data-product-id');
      var title = card.getAttribute('data-product-title');
      var image = card.getAttribute('data-product-image');
      var price = parseInt(card.getAttribute('data-product-price') || '0', 10);
      var sizeGuideImage = card.getAttribute('data-size-guide-image');

      var variantImg = card.querySelector('.product-variant-img');
      if (variantImg && !variantImg.dataset.initialized) {
        try {
          var variantImages = JSON.parse(card.dataset.variantImages || '[]');
          if (variantImages.length > 0) {
            variantImg.src = variantImages[Math.floor(Math.random() * variantImages.length)];
            variantImg.dataset.initialized = 'true';
          }
        } catch (e) { log('[Init] Error parsing variant images:', e); }
      }

      if (!productCardsAbortController) productCardsAbortController = new AbortController();
      card.addEventListener('click', function () {
        if (bottomBarSettings.enabled) openProductDrawer(handle, id, title, image, price, sizeGuideImage);
        else selectProductType(handle, id, title, image, sizeGuideImage);
      }, { signal: productCardsAbortController.signal });
      card.dataset.setupComplete = 'true';
    }

    // Set up every card eagerly so hover image swaps + click-to-open stay intact for
    // the whole page lifetime. A lazy IntersectionObserver left off-screen cards
    // un-initialized once the observer was disconnected (e.g. after going to step 2
    // and back), breaking their hover image and drawer. Variant images use
    // loading="lazy", so assigning src up front doesn't trigger off-screen requests.
    productCards.forEach(setupProductCard);

    // Global listeners
    globalListenersAbortController = new AbortController();

    var fabricMainImage = document.getElementById('fabric-main-image');
    var sizeVariantImage = document.getElementById('size-variant-image');
    if (fabricMainImage) fabricMainImage.addEventListener('click', function () { var u = this.dataset.zoomUrl || this.src; if (u) openImageZoom(u); }, { signal: globalListenersAbortController.signal });
    if (sizeVariantImage) sizeVariantImage.addEventListener('click', function () { var u = this.dataset.zoomUrl || this.src; if (u) openImageZoom(u); }, { signal: globalListenersAbortController.signal });

    // Step nav click handlers
    document.querySelectorAll('.steps-nav .step-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var targetStep = parseInt(this.getAttribute('data-step'));
        if (targetStep <= getCurrentStep()) navigateToStep(targetStep);
      }, { signal: globalListenersAbortController.signal });
    });

    // Step 1 scroll-down indicator
    var scrollDownBtn = document.getElementById('step1-scroll-down');
    if (scrollDownBtn) scrollDownBtn.addEventListener('click', scrollDownOneView, { signal: globalListenersAbortController.signal });
    window.addEventListener('scroll', updateScrollIndicator, { passive: true, signal: globalListenersAbortController.signal });
    window.addEventListener('resize', updateScrollIndicator, { signal: globalListenersAbortController.signal });
    window.addEventListener('load', updateScrollIndicator, { signal: globalListenersAbortController.signal });
    // #38 — lift the fixed bottom bar above the footer on scroll/resize
    window.addEventListener('scroll', adjustBarForFooter, { passive: true, signal: globalListenersAbortController.signal });
    window.addEventListener('resize', adjustBarForFooter, { signal: globalListenersAbortController.signal });
    updateStep1Footer();
    setTimeout(updateScrollIndicator, 400);

    // Step 2: horizontal fabric-row scroll (both directions), vertical thumbnail scroll, image zoom
    var fabricRow = document.querySelector('#step-2 .fabric-options');
    var fabricPrevBtn = document.querySelector('.fabric-scroll-prev');
    var fabricNextBtn = document.querySelector('.fabric-scroll-next');
    if (fabricNextBtn) fabricNextBtn.addEventListener('click', function () {
      if (fabricRow) fabricRow.scrollBy({ left: Math.round(fabricRow.clientWidth * 0.8), behavior: 'smooth' });
    }, { signal: globalListenersAbortController.signal });
    if (fabricPrevBtn) fabricPrevBtn.addEventListener('click', function () {
      if (fabricRow) fabricRow.scrollBy({ left: -Math.round(fabricRow.clientWidth * 0.8), behavior: 'smooth' });
    }, { signal: globalListenersAbortController.signal });
    if (fabricRow) fabricRow.addEventListener('scroll', updateFabricArrows, { passive: true, signal: globalListenersAbortController.signal });
    window.addEventListener('resize', updateFabricArrows, { signal: globalListenersAbortController.signal });
    setTimeout(updateFabricArrows, 300);

    document.querySelectorAll('.gallery-thumbs-scroll').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.closest('.gallery-thumbs-col');
        var thumbs = col ? col.querySelector('.gallery-thumbs') : null;
        if (thumbs) thumbs.scrollBy({ top: Math.round(thumbs.clientHeight * 0.8), behavior: 'smooth' });
      }, { signal: globalListenersAbortController.signal });
    });

    document.querySelectorAll('.gallery-zoom-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var main = btn.closest('.gallery-main');
        var img = main ? main.querySelector('img') : null;
        if (img && img.src) openImageZoom(img.dataset.zoomUrl || img.src);
      }, { signal: globalListenersAbortController.signal });
    });

    // Deep linking from URL
    var urlParams = getURLParams();
    var stepMatch = window.location.hash.match(/#step-(\d+)/);
    var initialStep = stepMatch ? parseInt(stepMatch[1], 10) : (urlParams.product ? 1 : 0);

    if (stepMatch) {
      document.querySelectorAll('.step').forEach(function (el) { el.classList.remove('active'); });
      var initialEl = document.getElementById('step-' + initialStep);
      if (initialEl) {
        initialEl.classList.add('active');
        var nav = document.getElementById('steps-nav');
        if (nav) { nav.style.display = initialStep > 0 ? 'flex' : 'none'; updateBreadcrumb(initialStep); }
        updateStepIndicatorPill(initialStep);
      }
    }

    if (urlParams.product) {
      restoreFromURL(urlParams, initialStep || 1);
    }
  });

  // ===== Public API for inline onclick handlers =====
  window.nextStep = nextStep;
  window.prevStep = prevStep;
  window.switchTab = switchTab;
  window.openHelpDrawer = openHelpDrawer;
  window.closeProductDrawer = closeProductDrawer;
  window.closeSizeGuide = closeSizeGuide;
  window.closeImageZoom = closeImageZoom;
  window.addToCart = addToCart;
  window.openSizeGuide = openSizeGuide;
  window.openProductDrawer = openProductDrawer;
  window.selectFabric = selectFabric;
  window.selectSize = selectSize;

})();
